import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import calendarIcon from '../../../assets/yourInfo/calendar-icon-dates.svg';
import './ImportantDatesNewDesign.css';
import { HtmlContent } from '../../common';

const DISCLAIMER_TEXT_ID = 3;

const ImportantDates = () => {
  const store = useSelector(({ quoting }) => quoting, shallowEqual);
  const { t } = useTranslation('quoting');

  const {
    data: {
      insuranceProductEB: {
        InsuranceInformationSectionsEB,
      },
    },
  } = store;

  const description = useMemo(() => {
    const disclaimerText = InsuranceInformationSectionsEB
      .find((item) => item.InsuranceInformationTypeEBId
        === DISCLAIMER_TEXT_ID)
      || { InsuranceInformationDetailsEB: [{}] };

    return disclaimerText.InsuranceInformationDetailsEB[0].Text || '';
  }, [InsuranceInformationSectionsEB]);

  const getEffectiveDate = () => {
    // TODO: work arround, open saved quote effective date is wrong
    const { effectiveDate } = store.data;

    const isValidDate = new Date(`${effectiveDate} 12:00:00`) > new Date();

    if (isValidDate) {
      return moment(effectiveDate);
    }

    return moment(Date.now()).add(1, 'days');
  };

  function renderImportantDatesList() {
    const { data } = store;
    const importantDates = data.insuranceProductEB.InsuranceWaitingPeriodsEB;
    const effectiveDate = getEffectiveDate();

    return importantDates.map((date) => {
      const dateText = moment(effectiveDate)
        .add(date.Units, date.IsMonth ? 'months' : 'days')
        .format('MMMM D, YYYY');

      return (
        <section
          key={String(date.Id)}
          className="Important-dates-invdividual-card"
        >
          <img
            alt=""
            className="Important-dates-invdividual-card-icon"
            src={calendarIcon}
          />

          <div className="Important-dates-invdividual-card-col">
            <span className="Important-dates-invdividual-card-title">
              {date.InsuranceWaitingPeriodTypeEB
                && date.InsuranceWaitingPeriodTypeEB.Name}
            </span>

            <span className="Important-dates-invdividual-card-description">
              {dateText}
            </span>
          </div>
        </section>
      );
    });
  }

  return (
    <div className="Important-dates-main-card">
      <h1 className="Important-dates-title-header">
        {t('importantDates.title')}
      </h1>

      <div className="Important-dates-cards-container">
        {renderImportantDatesList()}
      </div>

      <HtmlContent
        classNameContainer="Important-dates-description"
        content={description}
        elementId="important-dates-description"
        elementType="div"
        shouldRefresh
      />
    </div>
  );
};

export default ImportantDates;
